import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DateTime } from 'luxon';
import { take } from 'rxjs';
import { DailyTrackerService } from 'app/modules/daily-activity-tracker/services/daily-tracker.service';
import { DAT, DATType } from 'app/modules/daily-activity-tracker/model';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import module from 'app/modules/daily-activity-tracker/daily-activity-tracker.module';
import { CompleteFormComponent } from '../complete-form/complete-form.component';

@Component({
    selector: 'app-dat-form',
    templateUrl: './form.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: module,
    styleUrls: ['./form.component.scss'],
})
export class FormComponent {
    isUpdate: boolean = false;
    form: FormGroup;
    today = new Date();

    constructor(
        public dialogRef: MatDialogRef<FormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { payload: DAT, type: DATType },
        private service: DailyTrackerService,
        private formBuilder: FormBuilder,
        private dialog: MatDialog,
    ) { }

    ngOnInit() {
        this.isUpdate = false;
        this.setForm();
    }

    setForm() {
        const row = this.data.payload;

        this.form = this.formBuilder.group({
            id: new FormControl({ value: row.id, disabled: false }),
            startDate: new FormControl({
                value: row.startDate,
                disabled: false,
            }),
            activityStatus: new FormControl({ value: row.activityStatus, disabled: false }),
            statusUpdatedAt: new FormControl({
                value: row.statusUpdatedAt,
                disabled: false,
            }),
            endDate: new FormControl({ value: row.endDate, disabled: false }),
            dailyActivityTrackerDetails: this.formBuilder.array(
                row.dailyActivityTrackerDetails.map((activity) => {
                    return {
                        id: new FormControl({
                            value: activity.id,
                            disabled: true,
                        }),
                        activityDate: new FormControl({
                            value: activity.activityDate,
                            disabled: false,
                        }),
                        dailyActivity: new FormControl({
                            value: activity.dailyActivity,
                            disabled: false,
                        }),
                    };
                })
            ),
        });
    }

    addDetail() {
        const dailyActivityTrackerDetails = this.form.get(
            'dailyActivityTrackerDetails'
        ) as FormArray;
        const detail: any = new FormControl({
            id: new FormControl({
                value: null,
                disabled: false,
            }),
            activityDate: new FormControl({
                value: DateTime.now().toISO(),
                disabled: false,
            }),
            dailyActivity: new FormControl({
                value: null,
                disabled: false,
            }),
        });
        dailyActivityTrackerDetails.push(detail);
    }

    async deleteDetail(detail: any, index) {
        // IF null delete from form group, if otherwise call API

        const dailyActivityTrackerDetails = this.form.get(
            'dailyActivityTrackerDetails'
        ) as FormArray;

        const promise = () =>
            new Promise((resolve, reject) => {
                if (!detail.id.value) return resolve(true);
                return this.service
                    .deleteDailyActivity(detail.id.value)
                    .pipe(take(1))
                    .subscribe((response) => {
                        if (response.isSuccess) resolve(true);
                    });
            });

        try {
            await promise();
            dailyActivityTrackerDetails.removeAt(index);
        } catch (e) { }
    }

    completeDialog() {
        const dialogRef = this.dialog.open(CompleteFormComponent, {
            width: '30%',
        });

        dialogRef
            .afterClosed()
            .pipe(take(1))
            .subscribe((completedDate) => {
                if (completedDate) {
                    this.complete(completedDate)
                }
            });
    }

    complete(completedDate) {
        const form = {
            endDate: completedDate //DateTime.now().toSQL(),
        };

        switch (this.data.type) {
            case DATType.apr:
            case DATType.wrsv:
            case DATType.adhoc:
                form['activityStatus'] = 'Closed';
                form['statusUpdatedAt'] = DateTime.now().toSQL();
                break
            case DATType.cm:
                form['activityStatus'] = 'Closed';
                break
        }
        this.form.patchValue(form);

        this.update();
    }

    update() {
        const dailyActivityTrackerDetails = [];
        this.form.get("dailyActivityTrackerDetails").value.forEach(element => {
            dailyActivityTrackerDetails.push({
                id: element.id.value,
                activityDate: element.activityDate.value,
                dailyActivity: element.dailyActivity.value,

            });
        });
        const payload = { ...this.data.payload, ...this.form.value, dailyActivityTrackerDetails };
        this.service
            .updateDailyActivityTracker(payload)
            .pipe(take(1))
            .subscribe((response) => {
                this.isUpdate = true;
                this.closeDialog();
            });
    }

    closeDialog(): void {
        this.dialogRef.close(this.isUpdate);
    }
}
